export const DELETE_VENUE= 'DELETE_VENUE'
export const DELETE_VENUE_SUCCESS= 'DELETE_VENUE_SUCCESS'
export const DELETE_VENUE_ERROR='DELETE_VENUE_ERROR'

export const DeleteVenue= (data) => ({
    type: DELETE_VENUE,
    payload: data
})